import Button from "../../Custom/Button/Button";
import { useGlobalContext } from "../../../Context/Context";
import axios from "axios";
import { useState } from "react";
import ConfirmationModal from "../FolderDocument/ConfirmationModal";

const styles = {
  button: {
    padding: "10px 20px",
    fontWeight: "bold"
  },
  divBtn: {
    width: "90%",
    height: "40px"
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    padding: "5px"
  },
  btnContainer: {
    padding: "5px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "7px",
    alignItems: "center"
  }
};

const AktivirajIzbrisiBtns = ({ companyId, setArhiviranoId }) => {
  const [isConfirmDelete, setIsConfirmDelete] = useState(false);

  const { dictionary, baseUrl, setSelectedCompany } = useGlobalContext();

  const handleAktiviraj = async () => {
    try {
      const { data } = await axios.post(
        `${baseUrl}/companies/archiveToggle.php`,
        {
          company_id: companyId
        }
      );
      if (data.status === 200) {
        setSelectedCompany((prev) => ({
          ...prev,
          accounts: prev.accounts.map((account) =>
            account.company_id === companyId
              ? { ...account, archived: "0" }
              : account
          )
        }));
        setArhiviranoId("");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDelete = () => setIsConfirmDelete(true);

  const handleConfirmDelete = async () => {
    try {
      const { data } = await axios.post(`${baseUrl}/companies/delete.php`, {
        company_id: companyId
      });
      if (data.status === 200) {
        setSelectedCompany((prev) => ({
          ...prev,
          accounts: prev.accounts.filter(
            (account) => account.company_id !== companyId
          )
        }));
        setArhiviranoId("");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div style={styles.btnContainer}>
        <div onClick={handleAktiviraj} style={styles.divBtn}>
          <Button style={styles.button}>{dictionary["aktiviraj"]}</Button>
        </div>
        <div onClick={handleDelete} style={styles.divBtn}>
          <Button activation={true} style={styles.button}>
            {dictionary["izbrisi"]}
          </Button>
        </div>
      </div>

      {isConfirmDelete && (
        <ConfirmationModal
          handleConfirm={handleConfirmDelete}
          text={dictionary["confirmDeleteKlijent"]}
          handleCancel={() => setIsConfirmDelete(false)}
        />
      )}
    </>
  );
};

export default AktivirajIzbrisiBtns;
